module.exports = __webpack_public_path__ + "static/media/icon-lamp-white.0a7fc4f9.svg";